import { ChangeDetectorRef, Component, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory } from 'survey-angular-ui';
import { PaymentFormWidgetModel } from './payment-form.widget.model';
import { RendererFactory } from 'survey-core';
import { FormBuilder } from '@angular/forms';
import {
  RecnService
} from '@tangilla/tg-ng-payments';
import { PaymentFormWidgetJson } from './payment-form.widget.json';
import { QuestionsService } from '../../../../core/services/survey/questions.service';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { TangillaQuestion } from '../tangilla-question';
import { switchAll } from 'rxjs';
import { PaymentFormWidgetService } from './services/payment-form.widget.service';

@Component({
  selector: 'tgf-payment-form-widget',
  templateUrl: './payment-form.widget.component.html',
  styleUrls: ['./payment-form.widget.component.scss']
})
export class PaymentFormWidgetComponent extends TangillaQuestion<PaymentFormWidgetModel> {
  isLoading = false;
  isLoadingCharges = false;

  questionJson: any;
  paymentFormWidgetJson = new PaymentFormWidgetJson();

  constructor(
    private recnService: RecnService,
    private paymentFormWidgetService: PaymentFormWidgetService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef) {
    super(formBuilder, surveyService, questionsService, changeDetectorRef, viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.recnService.source = 'Tangilla Forms';
    this.surveyService.surveyModel.showCompleteButton = false;
    this.initQuestionJson();
  }

  initQuestionJson() {
    this.questionJson = this.paymentFormWidgetJson.getWidgetJson(this.questionForm);
  }

  isItLoading() {
    return this.isLoading ||
      this.isLoadingCharges;
  }

  isCreditCardPayment() {
    return this.questionsService.paymentMethod?.value === 'CreditCard';
  }

  isTelecheckPayment() {
    return this.questionsService.paymentMethod?.value === 'TeleCheck';
  }

  switchToCreditCard() {
    this.questionsService.paymentMethod.value = 'CreditCard';
    this.paymentFormWidgetService.telecheckDeclined = false;
    this.surveyService.showNextButton(true);
    this.changeDetectorRef.detectChanges();
  }

  protected readonly switchAll = switchAll;
}

RendererFactory.Instance.registerRenderer(
  'payment_form',
  'payment_form',
  'tg_payment_form',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_payment_form', PaymentFormWidgetComponent);
